import DateRangePicker                              from '@wojtekmaj/react-daterange-picker';
import 'react-calendar/dist/Calendar.css';
import moment                                       from 'moment';
import { FC, useState }                             from 'react';
import { ReactComponent as IconDate }               from '../../../../images/icons/icon-date.svg';
import { IconRemove }                               from '../../../modules/MyFamilyCore/shared/styles';
import { DashedButtonIconLabel, DatePickerWrapper } from '../../styledComponents';

interface ISelectDateRangeProps {
  endDate?: string;
  startDate?: string;
  isSyncEnabled?: boolean;

  onRangeChange(value: Date[] | null): void;
}

export const SelectDateRange: FC<ISelectDateRangeProps> = (props) => {
  const [ isOpen, setIsOpen ] = useState(false);

  const { onRangeChange, isSyncEnabled } = props;
  const startDate = props.startDate ? moment(props.startDate) : null;
  const endDate = props.endDate ? moment(props.endDate) : null;

  const sameYear = endDate?.year() === startDate?.year();
  const sameMonth = endDate?.month() === startDate?.month();
  const sameDate = endDate?.date() === startDate?.date();
  const sameFullDate = endDate?.isSame(startDate, 'day');

  let startDateFormatted = '';
  let endDateFormatted = '';

  if (startDate) {
    startDateFormatted = sameYear ? startDate.format('MMM D') : startDate.format('MMM D, YYYY');
  }

  if (endDate) {
    if (sameFullDate) {
      endDateFormatted = '';
    } else if (sameMonth && sameYear) {
      endDateFormatted = endDate.format('D');
    } else if (sameYear) {
      endDateFormatted = endDate.format('MMM D');
    } else {
      endDateFormatted = endDate.format('MMM D, YYYY');
    }
  }

  let formattedRange = startDateFormatted;

  if (startDate && endDate && endDateFormatted) {
    formattedRange += ' - ' + endDateFormatted;
    if (sameYear) {
      formattedRange += `, ${startDate.year()}`;
    }
  }

  const displayText = isSyncEnabled ? 'Choose Sync/Unsync Date' : 'Choose a date';

  const onClose = (event: any) => {
    event.stopPropagation();
    onRangeChange(null);
  };

  const handleDateChange = (value: Date | [Date | null, Date | null] | null) => {
    // DateRangePicker can return a single Date, a tuple with nullable dates, or null
    if (value === null) {
      onRangeChange(null);
    } else if (Array.isArray(value)) {
      // Filter out null values from the array
      const [start, end] = value;
      if (start && end) {
        onRangeChange([start, end]);
      } else {
        onRangeChange(null);
      }
    } else {
      // Single date - convert to tuple with same start/end
      onRangeChange([value, value]);
    }
  };

  return (
    <>
      <DatePickerWrapper
        isSelectDate
        empty={!startDate}
        onClick={() => setIsOpen(!isOpen)}
      >
        <DashedButtonIconLabel>
          <IconDate />
          { startDate ? formattedRange : '' }
        </DashedButtonIconLabel>

        { startDate ? <IconRemove onClick={onClose} /> : displayText }
      </DatePickerWrapper>
        {isOpen &&
      <DateRangePicker
        key={isOpen ? 'open' : 'closed'}
        format="MMM dd"
        isOpen={isOpen}
        locale="en-US"
        calendarIcon={<IconDate />}
        clearIcon={<IconRemove />}
        openCalendarOnFocus={false}
        value={startDate && endDate ? [startDate.toDate(), endDate.toDate()] : null}
        onChange={handleDateChange as any}
        onCalendarClose={() => setIsOpen(false)}
      /> }
    </>
  );
};
